import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceAreas() {
  const arizonaCities = ['Yuma', 'Somerton', 'San Luis', 'Wellton', 'Fortuna Foothills', 'Phoenix', 'Scottsdale', 'Casa Grande', 'Tucson'];
  const californiaCities = ['El Centro', 'Calexico', 'Imperial', 'Brawley', 'El Cajon', 'Chula Vista', 'San Diego', 'Palm Springs', 'and surrounding areas'];
  return <section className="bg-white py-20 lg:py-28 font-heading" data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-145">
            Serving Arizona & Southern California
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto mb-12" data-id="element-146">
          {/* Arizona Column */}
          <div className="bg-[#F5F7FA] rounded-xl p-8 shadow-sm" data-id="element-147">
            <h3 className="text-2xl font-bold text-[#1B3A5C] mb-6 flex items-center gap-3 border-b border-[#1B3A5C]/10 pb-4" data-id="element-148">
              <MapPin className="w-6 h-6 text-[#F5A623]" data-id="element-149" />
              Arizona
            </h3>
            <ul className="space-y-4" data-id="element-150">
              {arizonaCities.map((city, index) => <li key={index} className="text-[#1E1E1E] flex items-start gap-2" data-id="element-151">
                  <span className="text-[#F5A623] font-bold" data-id="element-152">•</span>
                  {city}
                </li>)}
            </ul>
          </div>

          {/* California Column */}
          <div className="bg-[#F5F7FA] rounded-xl p-8 shadow-sm" data-id="element-153">
            <h3 className="text-2xl font-bold text-[#1B3A5C] mb-6 flex items-center gap-3 border-b border-[#1B3A5C]/10 pb-4" data-id="element-154">
              <MapPin className="w-6 h-6 text-[#F5A623]" data-id="element-155" />
              California
            </h3>
            <ul className="space-y-4" data-id="element-156">
              {californiaCities.map((city, index) => <li key={index} className="text-[#1E1E1E] flex items-start gap-2" data-id="element-157">
                  <span className="text-[#F5A623] font-bold" data-id="element-158">•</span>
                  {city}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-159">
          <p className="text-[#1E1E1E]/80 italic text-lg" data-id="element-160">
            Don't see your area? Contact us — we may still be able to help.
          </p>
        </div>
      </div>
    </section>;
}